import type { ReactNode } from 'react';

type Tone = 'error' | 'success' | 'info';

/**
 * Inline status message. Errors get `role="alert"` so they interrupt; the calmer tones use a
 * polite live region so a success note doesn't talk over whatever the user is doing.
 */
export function Callout({ tone = 'info', title, children }: { tone?: Tone; title?: string; children: ReactNode }) {
  return (
    <div
      className={`callout callout--${tone}`}
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
    >
      {title && <strong className="callout__title">{title}</strong>}
      <div>{children}</div>
    </div>
  );
}
